import {createAction} from 'redux-actions'

export const loadBoard = createAction('LOAD_BOARD')
export const addLane = createAction('ADD_LANE')
